module.exports = __webpack_public_path__ + "static/media/aisc.f018f4fb.png";